import { observable, action, computed, createTransformer, reaction } from "mobx";
import TarefaService from "../../../services/TarefaService";
import UsuarioService from "../../../services/UsuarioService";
import moment from 'moment';
import _ from "lodash";
import DelegacaoTarefaService from "../../../services/DelegacaoTarefaService";
import {toast} from "react-toastify";
import axios from "axios";

export default class DelegacaoTarefasStore {

    @observable momentDataInicio;
    @observable momentDataTermino;
    @observable isAtiva;
    @observable delegacao;
    @observable delegacaoSalva;
    @observable modoEdicao;
    @observable dataTerminoValidacao;
    @observable dataInicioValidacao;
    @observable carregando;
    @observable usandoDadosExternos;


    constructor(formStore, validacaoStore) {
        this.formStore = formStore;
        this.validacaoStore = validacaoStore;
        this.usandoDadosExternos = false;
        this.modoEdicao = false;
        this.resetDelegacao();
        this.formStore.solicitando = false;
        this.isAtiva = false;
        this.delegacaoSalva = this.delegacao;

        this.usuarioService = new UsuarioService();
        this.tarefaService = new TarefaService();
        this.delegacaoTarefaService = new DelegacaoTarefaService();

        this.filtrarUsuarios = _.debounce(this._filtrarUsuariosPorNome, 1000);
    }

    @computed
    get exibeBotaoAtivar() {
        return this.usandoDadosExternos;
    }

    carregarDados() {
        this.formStore.solicitando = true;
        this.delegacaoTarefaService.listarDelegacoesUsuario().then(response => {
            this.formStore.solicitando = false;

            if(response && response.status == 200) {
                if(response.data != undefined && response.data != null && response.data.length > 0){
                    this.carregarDadosRegra(response.data[0]);
                }
                else{
                    this.resetDelegacao();
                }
            }
            else{
                this.resetDelegacao();
            }
        }).catch(error => {
            this.formStore.solicitando = false;
            console.log(error)
        })
    }

    @computed
    get apenasCpfUsuarioDelegado() {
        if(this.delegacao.usuarioDelegado && typeof this.delegacao.usuarioDelegado === "object") {
            return this.delegacao.usuarioDelegado.value;
        } else if(this.delegacao.usuarioDelegado) {
            return this.delegacao.usuarioDelegado;
        } else {
            return null;
        }
    }

    resetDelegacao() {
        this.delegacao = {
            idDelegacao: null,
            codigoRegra: null,
            ativa: true,
            usuarioResponsavel: null,
            usuarioDelegado: null,
            dataInicio: null,
            dataTermino: null
        };
        this.isAtiva = true;
        this.momentDataTermino = "";
        this.momentDataInicio = "";
        this.dataInicioValidacao = null;
        this.dataTerminoValidacao = null;
    }

    editar() {
        this.delegacaoSalva = Object.assign({}, this.delegacao);
        this.toggleModoEdicao();
    }

    reverter() {
        this.isAtiva = this.delegacaoSalva.ativa;
        this.carregarDadosRegra(this.delegacaoSalva);
        this.toggleModoEdicao();
    }

    salvar() {
        this.formStore.setSubmitted(true);
        this.formStore.setSubmitMensagemErro("");
        if (this.validacaoStore.isValidForm) {
            this.carregando = true;
            this.delegacaoTarefaService.editarDelegacao(this.delegacao).then(response => {
                if(!this.delegacao.ativa) {
                    this.usandoDadosExternos = false;
                }
                this.carregarDadosRegra(response.data);
                this.toggleModoEdicao();
                this.carregando = false;
                toast.success("Delegação salva com sucesso.");
            }).catch(error => {
                this.carregando = false;
                if(_.get(error, "response.data.message")) {
                    if (axios.isCancel(error)) {
                        toast.error("Operação de delegação cancelada.");
                    } else {
                        toast.error(error.response.data.message);
                    }
                }
            });
        }
    }

    carregarDadosRegra(dados){
        if(dados.codigoRegra){
            this.usandoDadosExternos = true;
            this.delegacao = Object.assign({}, dados);
            if(dados.dataInicio){
                this.setMomentDataInicio(moment(dados.dataInicio));
            }
            if(dados.dataTermino){
                this.setMomentDataTermino(moment(dados.dataTermino));
            }
            this.isAtiva = dados.ativa;
        }
        else{
            this.resetDelegacao();
        }
    }

    toggleModoEdicao() {
        this.modoEdicao = !this.modoEdicao;
    }

    setUsuarioDelegado(value) {
        this.delegacao.usuarioDelegado = value;
    }

    setMomentDataInicio(value) {

        if(value) {
            let startDate = value;
            startDate = moment(startDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            let endDate = this.momentDataTermino;
            if (endDate && startDate && startDate.isAfter(endDate)) {
                const temp = startDate;
                startDate = endDate;
                endDate = temp
            }
            this.momentDataInicio = startDate;
            if (startDate) {
                this.delegacao.dataInicio = startDate.toJSON();
            }
            else {
                this.delegacao.dataInicio = null;
            }
            this.momentDataTermino = endDate;
            if (endDate) {
                this.delegacao.dataTermino = endDate.toJSON();
            }
            else {
                this.delegacao.dataTermino = null;
            }
            this.dataInicioValidacao =  moment(value).format('DD/MM/YYYY');
        } else {
            this.momentDataInicio = null;
            this.delegacao.dataInicio = null;
            this.dataInicioValidacao = null;
        }

    }

    setMomentDataTermino(value) {
        if(value) {
            let startDate = this.momentDataInicio;
            let endDate = value;
            endDate = moment(endDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            if (endDate && startDate && startDate.isAfter(endDate)) {
                const temp = startDate;
                startDate = endDate;
                endDate = temp;
            }
            this.momentDataInicio = startDate;
            if (startDate) {
                this.delegacao.dataInicio = startDate.toJSON();
            }
            else {
                this.delegacao.dataInicio = null;
            }
            this.momentDataTermino = endDate;
            if (endDate) {
                this.delegacao.dataTermino = endDate.toJSON();
            }
            else {
                this.delegacao.dataTermino = null;
            }
            this.dataTerminoValidacao =  moment(value).format('DD/MM/YYYY');
        } else {
            this.momentDataTermino = null;
            this.delegacao.dataTermino = null;
            this.dataTerminoValidacao = null;
        }

    }

    _filtrarUsuariosPorNome(input, callback) {
        let result = [];
        if(input && input.length > 1) {
            this.usuarioService.filterByName(input).then(response => {
                if(response.data) {
                    response.data.map(usuario => {
                        result.push({value: usuario.login, label: usuario.nome});
                    });
                }
                callback(null, {
                    options: result,
                    // CAREFUL! Only set this to true when there are no more options,
                    // or more specific queries will not be sent to the server.
                    complete: false
                });
            });
        } else {
            callback(null, {
                options: result,
                complete: false
            });
        }
    }

    setDataTerminoCheck(value){
        this.dataTerminoValidacao = value;
        if(!value) {
            this.momentDataTermino = null;
        }
    }

    setDataInicioCheck(value){
        this.dataInicioValidacao = value;
        if(!value) {
            this.momentDataInicio = null;
        }
    }

    toggleAtiva() {
        this.delegacao.ativa = !this.delegacao.ativa;
        if(!this.delegacao.ativa) {
            this.momentDataTermino = "";
            this.momentDataInicio = "";
            this.delegacao.dataInicio = "";
            this.delegacao.dataTermino = "";
            this.dataInicioValidacao = null;
            this.dataTerminoValidacao = null;
            this.delegacao.usuarioDelegado = "";
        }

    }

}